<template>
  <div
    v-show="!zone.hide"
    :key="zone.id"
    @mouseover="zone.targetCursor ? (hover = true) : null"
    @mouseleave="zone.targetCursor ? (hover = false) : null"
    :class="`drop-zone ${hover ? 'hover ' + zone.hoverClass : ''} ${zone.zoneClass}`"
    :style="zone.style"
    ref="zone"
  >
    <v-layout
      v-if="zone.zoneText || zone.zoneIcon"
      align-center
      justify-center
      fill-height
      class=""
    >
      <div class="px-6 py-2 drop-zone-content">
        <v-icon v-if="zone.zoneIcon" class="drop-zone-icon">{{ zone.zoneIcon }}</v-icon>
        <span v-if="zone.zoneText" v-text="zone.zoneText" class="drop-zone-text"></span>
      </div>
    </v-layout>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    zone: {
      type: Object,
      default: () => ({
        id: 'zone1',
        show: true, // render the element
        hide: false, // hide the rendered element and disable drop
        style: {},
        targetCursor: false,
        hoverClass: '',
        zoneClass: '',
        hoverWidth: false,
        zoneText: false,
        onDrop() {
          this.$emit('drop');
        }
      })
    }
  },
  data() {
    return {
      hover: false,
      boxEl: null,
      draggedWidth: 0
    };
  },
  beforeDestroy() {
    if (this.hover) {
      this.onMouseUp();
    }
  },
  mounted() {
    this.boxEl = this.$refs.zone;
    this.draggedWidth = this.draggedData.element ? this.draggedData.element.offsetWidth : 0;
  },
  watch: {
    zone: function(n, o) {
      if (!o.show && n.show) {
        //  we went from not showing to showing
        this.boxEl = this.$refs.zone;
        this.draggedWidth = this.draggedData.element.offsetWidth;
      }
    },
    areaHover: function(n, o) {
      if (!this.zone.targetCursor) {
        this.hover = n;
      }
    }
  },
  computed: {
    ...mapState('components/dragdrop', ['dragPosition', 'draggedData']),
    areaHover() {
      // return false;
      if (this.zone.show && this.boxEl && !this.zone.targetCursor) {
        const boxA = this.boxEl.getBoundingClientRect();
        const width = this.zone.hoverWidth || this.draggedWidth;
        const boxB = {
          left:
            this.zone.hoverCorner == 'right'
              ? this.dragPosition.x - this.draggedData.shift.x + this.draggedWidth - width
              : this.dragPosition.x - this.draggedData.shift.x,
          top: this.dragPosition.y - this.draggedData.shift.y,
          width,
          height: 1
        };
        // console.log(boxA, boxB)
        // console.log(el);
        // const boxB = {
        //   top: el.offsetTop,
        //   left: el.offsetLeft,
        //   width: el.clientWidth,
        //   height: el.clientHeight
        // };

        return !!(
          boxA.left <= boxB.left + boxB.width &&
          boxA.left + boxA.width >= boxB.left &&
          boxA.top <= boxB.top + boxB.height &&
          boxA.top + boxA.height >= boxB.top
        );
      }

      return false;
    }
  },
  methods: {
    onMouseUp() {
      if (this.hover && !this.zone.hide) {
        this.zone.onDrop();
      }
    }
  }
};
</script>

<style>
.drop-zone {
  position: absolute;
  z-index: 1000;
  pointer-events: all;
}

.drop-zone-text {
  margin-left: auto;
  margin-right: auto;
}
</style>
